import React, { useState } from "react";
import Body from "./Body";

const Admission = () => {
  const [date, setDate] = useState(new Date());
  const [filter, setFilter] = useState("");
  const [classesFilter, setClassesFilter] = useState("");
  const [yearFilter, setYearFilter] = useState([date && date.getFullYear()]);
  console.log(yearFilter);
  const [chartData, setChartData] = useState([
    {
      name: "Nursery",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 1",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 2",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 3",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Class 4",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 5",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Class 6",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 7",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Class 8",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 9",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Class 10",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Class 11",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Class 12",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Sports 1",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Sports 2",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
    {
      name: "Sports 3",
      admissionVacancy: 10,
      reAdmissionVacancy: 20,
      admission: 5,
      reAdmission: 93,
    },
    {
      name: "Sports 4",
      admissionVacancy: 30,
      reAdmissionVacancy: 20,
      admission: 127,
      reAdmission: 93,
    },
  ]);
  const _this = {
    filter,
    setFilter,
    classesFilter,
    setClassesFilter,
    yearFilter,
    setYearFilter,
    date,
    setDate,
    chartData,
    setChartData,
  };
  return <Body {..._this} />;
};

export default Admission;
